import { render, staticRenderFns } from "./DonorDetailsPrint.vue?vue&type=template&id=35469be1"
import script from "./DonorDetailsPrint.vue?vue&type=script&lang=js"
export * from "./DonorDetailsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports